const ATOMS_PER_MINOR = 1_000_000_000_000n;

/** Formats USD atoms exactly with 100 cents per dollar; unsupported currencies never become USD amounts. */
export function formatAtoms(atoms: string, currency: string): string {
  if (currency !== "usd") return "Unsupported currency";
  const digits = 2;
  const value = BigInt(atoms);
  const sign = value < 0n ? "-" : "";
  const absolute = value < 0n ? -value : value;
  const scale = ATOMS_PER_MINOR * 10n ** BigInt(digits);
  const fraction = (absolute % scale)
    .toString()
    .padStart(12 + digits, "0")
    .replace(/0+$/, "")
    .padEnd(digits, "0");
  return `${currency.toUpperCase()} ${sign}${absolute / scale}${fraction ? `.${fraction}` : ""}`;
}

/** Formats the available-balance presentation without changing stored atom precision. */
export function formatAvailableBalance(
  atoms: string,
  currency: string,
): string {
  const exact = formatAtoms(atoms, currency);
  return formatSymbolFirstUsd(exact, currency);
}

function formatSymbolFirstUsd(exact: string, currency: string): string {
  if (exact === "Unsupported currency") return exact;

  const amount = exact.slice(currency.length + 1);
  const sign = amount.startsWith("-") ? "-" : "";
  const unsignedAmount = sign ? amount.slice(1) : amount;
  return `${sign}$${unsignedAmount} ${currency.toUpperCase()}`;
}

/** Formats a selectable credit package without changing its Stripe minor-unit value. */
export function formatCreditAmount(minor: number, currency: string): string {
  return formatSymbolFirstUsd(formatMinor(minor, currency), currency);
}

/** Formats USD cents without Number arithmetic; unsupported currency is explicit display state. */
export function formatMinor(minor: number, currency: string): string {
  return formatAtoms((BigInt(minor) * ATOMS_PER_MINOR).toString(), currency);
}
